import { useEffect, useState } from "react";

import { Grid, Tooltip } from "@material-ui/core";

import { LabelStyled } from "../../../../theme/styles/Layout";
import Card from "../../../../components/cards/Card";
import MaskService from "../../../../utils/mask/maskService";
import { LabelItemContract } from "../styles/TriagemContrato";

const CardItemContract = ({ items = [], type }) => {
  const [total, setTotal] = useState(0);

  useEffect(() => {
    if (!Array.isArray(items)) return;

    let tot = 0;

    items.forEach((item) => {
      if (
        item?.integration_details?.tiposervico ===
        (type === "recorrente" ? "R" : "A")
      ) {
        tot += parseFloat(item?.total_value_with_discount || 0);
      }
    });

    setTotal(tot.toFixed(2));
  }, [items, type]);

  return (
    <Card chipcolor="transparent" line="left" lineColor="blue" fullWidth={true}>
      <Grid item container spacing={1}>
        <Grid item container justifyContent="space-between">
          <LabelItemContract>Descrição</LabelItemContract>

          <Grid item container justifyContent="space-between" xs={4}>
            <LabelItemContract>Un</LabelItemContract>
            <LabelItemContract>Qtd</LabelItemContract>
            <LabelItemContract>Perc</LabelItemContract>
            <LabelItemContract>Total</LabelItemContract>
          </Grid>
        </Grid>
        {(items || []).map((item, index) => {
          const serviceDescription = item.integration_details?.descricao || "";

          if (
            item?.integration_details?.tiposervico ===
            (type === "recorrente" ? "R" : "A")
          ) {
            return (
              <Grid
                key={item?.code || index}
                item
                container
                justifyContent="space-between"
              >
                <Tooltip title={serviceDescription}>
                  <LabelStyled
                    $cursor="pointer"
                    $fontFamily="Open Sans"
                    $color={item.integration_code ? "black" : "red"}
                  >
                    {serviceDescription.substring(0, 58)}
                  </LabelStyled>
                </Tooltip>

                <Grid item container justifyContent="space-between" xs={4}>
                  <LabelStyled $fontFamily="Open Sans">
                    R${" "}
                    {MaskService.toMask(
                      "decimal",
                      (
                        parseFloat(item?.total_value_with_discount || 0) /
                        parseFloat(item?.quantity || 0)
                      ).toFixed(2)
                    )}
                  </LabelStyled>
                  <LabelStyled $fontFamily="Open Sans">
                    {item?.quantity || 0}
                  </LabelStyled>
                  <LabelStyled $fontFamily="Open Sans">
                    {`${(item?.discount_percentage || 0).toFixed(2)}%`}
                  </LabelStyled>
                  <LabelStyled $fontFamily="Open Sans">
                    R${" "}
                    {MaskService.toMask(
                      "decimal",
                      parseFloat(item?.total_value_with_discount || 0).toFixed(
                        2
                      )
                    )}
                  </LabelStyled>
                </Grid>
              </Grid>
            );
          } else return null;
        })}

        <Grid
          item
          container
          justifyContent="space-between"
          alignItems="flex-end"
        >
          <LabelItemContract>TOTAL</LabelItemContract>
          <LabelItemContract>
            R$ {MaskService.toMask("decimal", total)}
          </LabelItemContract>
        </Grid>
      </Grid>
    </Card>
  );
};

export { CardItemContract };
